import React from 'react'
import PropTypes from 'prop-types'

import SearchModuleDestination from '../SearchModuleDestination';
import SearchModuleRooms from '../SearchModuleRooms';
import SearchModuleDates from '../SearchModuleDates';
import SearchModuleSpecialRates from '../SearchModuleSpecialRates';
import {MODULE_DATES, MODULE_DESTINATION, MODULE_ROOMS, MODULE_SPECIAL_RATES} from '../../constants';

const mapModules = {
  [MODULE_DESTINATION]: SearchModuleDestination,
  [MODULE_ROOMS]: SearchModuleRooms,
  [MODULE_DATES]: SearchModuleDates,
  [MODULE_SPECIAL_RATES]: SearchModuleSpecialRates,
}

const ModuleByKey = function ({type, className, ...props}) {
  const ModuleComponent = mapModules[type]
  return (<ModuleComponent {...props} />)
}

ModuleByKey.propTypes = {
  data: PropTypes.any
}

export default ModuleByKey;
